export default __webpack_public_path__ + "static/media/1372.cf01ff25.png";